import { useLocation } from 'react-router-dom';

import { PING_FEDERATE_URL } from 'constants/constants';
import { useDispatch } from 'react-redux';
import { resetAppStore } from 'utils/utils';
import { isTokenExpired } from '../../utils/token-expired';

const Authentication = ({ authToken, children }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const pages = ['authenticate', 'logout', 'maintenance', 'unauthorized'];
  const isReturnChild = pages.some((loc) => location.pathname.includes(loc));
  const isExpiredToken = isTokenExpired(localStorage.getItem('token'));

  //(authenticated and valid token) or includes listed path

  if ((!authToken.isLoading && !isExpiredToken) || isReturnChild) {
    return children;
  } else if (isExpiredToken) {
    resetAppStore(dispatch);
    window.location.href = PING_FEDERATE_URL;
    return <></>;
  } else {
    return children;
  }
};

export default Authentication;
